import {Pipe, PipeTransform} from '@angular/core';
import {UserRoleRes} from '@yasc/yasc-material-components';

@Pipe({
    name: 'roleIncludes',
    standalone: false
})
export class RoleIncludesPipe implements PipeTransform {

  transform(value: UserRoleRes[], include:string): boolean {
      if(value.length <= 0)
          return false
      return value.some(x => x.name === include)
  }

}
